import React from "react";
import Section from "@/components/foundation/Section";
import Timeline from "@/components/marketing/Timeline";
import { AutoLinkPartners } from "@/components/marketing/PartnerLink";

const RAW_STEPS = [
  {
    label: "Join the Waitlist",
    description:
      "Reserve your spot for early access — we'll notify you the moment we're live.",
  },
  {
    label: "Connect Your Bank",
    description:
      "Securely link your business bank account via Mastercard Finicity.",
  },
  {
    label: "AI Analysis",
    description:
      "Revenue, deposits, balances, and cash flow are analyzed in real time.",
  },
  {
    label: "Get Your ZenScore",
    description:
      "Generate your funding readiness profile with clear, actionable insights.",
  },
  {
    label: "Apply for Funding",
    description:
      "Complete a streamlined application powered by verified banking data.",
  },
  {
    label: "Match with Partners",
    description:
      "Qualified businesses are matched to relevant funding opportunities.",
  },
];

const STEPS = RAW_STEPS.map((s) => ({
  label: s.label,
  description: <AutoLinkPartners text={s.description} />,
}));

export const HowItWorksSection = () => {
  return (
    <Section
      eyebrow="How It Works"
      headline="From bank connection to funding, in six steps."
      subheadline="A streamlined path from onboarding to matched funding opportunities — powered by secure banking data and AI underwriting."
      spacing="lg"
      className="relative"
    >
      <div className="mt-4" data-testid="how-it-works-section">
        <Timeline steps={STEPS} />
      </div>
    </Section>
  );
};

export default HowItWorksSection;
